import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { authApi } from '@/modules/auth/services/auth-api'
import { useAuthStore } from '@/store/use-auth-store'

export function useLogout(): () => void {
  const navigate = useNavigate()
  const accessToken = useAuthStore((state) => state.accessToken)
  const clearSession = useAuthStore((state) => state.clearSession)

  return useCallback(() => {
    void (async () => {
      try {
        if (accessToken) {
          await authApi.logout(accessToken)
        }
      } finally {
        clearSession()
        navigate('/', { replace: true })
      }
    })()
  }, [accessToken, clearSession, navigate])
}
